import { render, staticRenderFns } from "./Branding.vue?vue&type=template&id=b3511832&scoped=true"
import script from "./Branding.vue?vue&type=script&lang=js"
export * from "./Branding.vue?vue&type=script&lang=js"
import style0 from "./Branding.vue?vue&type=style&index=0&id=b3511832&prod&lang=scss&scoped=true"
import style1 from "./Branding.vue?vue&type=style&index=1&id=b3511832&prod&scoped=true&lang=css"
import style2 from "./Branding.vue?vue&type=style&index=2&id=b3511832&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3511832",
  null
  
)

export default component.exports